export default __webpack_public_path__ + "static/media/ios_share.958522cb.svg";